import { ReactNode } from 'react';

import {
  DiscordIconHeader,
  DocumentsIcon,
  EducationIcon,
  TelegramIconHeader,
  TwitterIconHeader,
  YoutubeIconHeader,
} from '@constants/common/icons.constants';
import {
  DISCORD_LINK,
  TELEGRAM_LINK,
  TWITTER_LINK,
  YOUTUBE_LINK,
} from '@constants/common/links.constants';
import {
  PATH_DEX_ETF,
  PATH_DOCUMENTATION,
  PATH_EDUCATION,
  PATH_GDEX,
  PATH_LEADERBOARD,
  PATH_USDEX,
  PATH_VAULTS,
} from '@constants/common/routes.constants';

export const FOOTER_DESCRIPTION = `DexFi is a Decentralized Autonomous Organization (DAO) offering an ecosystem of
  financial products designed to empower users and simplify the DeFi experience.`;

export const QUICK_LINKS = [
  [
    {
      title: 'Vaults',
      href: PATH_VAULTS,
      isDisable: false,
    },
    {
      title: 'ETFs',
      href: PATH_DEX_ETF,
      isDisable: false,
    },
    {
      title: 'Spot',
      href: 'https://legacy.dexfi.com/swap',
      isDisable: false,
      newTab: true,
    },
    {
      title: 'DAO',
      href: 'https://legacy.dexfi.com/dexDAO',
      isDisable: false,
      newTab: true,
    },
  ],
  [
    {
      title: 'gDEX',
      href: PATH_GDEX,
      isDisable: false,
    },
    {
      title: 'USDEX+',
      href: PATH_USDEX,
      isDisable: false,
    },
    {
      title: 'Leaderboard',
      href: PATH_LEADERBOARD,
      isDisable: false,
    },
  ],
];

export const QUICK_LINKS_MOB = [
  [
    {
      title: 'Spot',
      href: 'https://legacy.dexfi.com/swap',
      isDisable: false,
      newTab: true,
    },
    {
      title: 'Vaults',
      href: PATH_VAULTS,
      isDisable: false,
    },
    {
      title: 'ETFs',
      href: PATH_DEX_ETF,
      isDisable: false,
    },
    {
      title: 'DAO',
      href: 'https://legacy.dexfi.com/dexDAO',
      isDisable: false,
      newTab: true,
    },
  ],
  [
    {
      title: 'gDEX',
      href: PATH_GDEX,
      isDisable: false,
    },
    {
      title: 'USDEX+',
      href: PATH_USDEX,
      isDisable: false,
    },
    {
      title: 'Leaderboard',
      href: PATH_LEADERBOARD,
      isDisable: false,
    },
  ],
];

type SocialItem = {
  title: string;
  path: string;
  icon: ReactNode;
  disabled?: boolean;
};

export const SOCIAL_LINKS: SocialItem[] = [
  {
    title: 'Discord',
    path: DISCORD_LINK,
    icon: DiscordIconHeader,
  },
  {
    title: 'Telegram',
    path: TELEGRAM_LINK,
    icon: TelegramIconHeader,
  },
  {
    title: 'Twitter',
    path: TWITTER_LINK,
    icon: TwitterIconHeader,
  },
  {
    title: 'YouTube',
    path: YOUTUBE_LINK,
    icon: YoutubeIconHeader,
  },
  {
    title: 'Docs',
    path: PATH_DOCUMENTATION,
    icon: DocumentsIcon,
  },
  {
    title: 'Education',
    path: PATH_EDUCATION,
    icon: EducationIcon,
  },
];
